import { CommonModule } from "@angular/common";
import { NgModule, Sanitizer } from "@angular/core";
import { BrowserModule, DomSanitizer } from "@angular/platform-browser";

import { RedirectService } from "@local/app/common/redirect.service";

import { AuthContainerComponentModule } from "./auth-container";

@NgModule({
  imports: [CommonModule, BrowserModule],
  providers: [
    RedirectService,
    {
      provide: Sanitizer,
      useExisting: DomSanitizer
    }
  ],
  exports: [AuthContainerComponentModule]
})
export class LocalCommonModule {}
